import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const token = 'token'
const userInfo = 'userInfo' //当前用户信息

const store = new Vuex.Store({
	state() {
		return {
			token: localStorage.getItem(token) ? localStorage.getItem(token) : '',
			userInfo: ''
		}
	},
	getters: {
		getToken: function(state) {
			if (!state.token) {
				state.token = JSON.parse(localStorage.getItem(token))
			}
			return state.token
		},
		getuserInfo: function(state) {
			state.userInfo = localStorage.getItem(userInfo)
			return state.userInfo
		}
	},
	mutations: {
		$_setToken(state, value) {
			state.token = value
			localStorage.setItem(token, value)
		},
		/**
		 * 登录并将用户信息缓存并存入缓存中
		 * @param {*} state 
		 * @param {*} provider 
		 */
		$_login(state, provider) {
			state.userInfo = provider;
			localStorage.setItem(userInfo, JSON.stringify(provider));
		},
		$_removeStorage(state) {
			state.token = null
			localStorage.removeItem(token)
			localStorage.removeItem(userInfo)
		}
	}
})
export default store
